<script>
import Endpoints from '../../../common/Endpoints.vue'
import Request from '../../../common/Request.vue'
import Common from '../../../common/Common.vue'
import Services from '../../../common/Services.vue'
import { applySessionScope } from '../../../utils/scope'
export default {
    init: async payload => {
        payload.domain = Endpoints.domain

        await payload.initTable()

        payload.isSuperAdminMaster = await Common.isSuperAdminMaster(payload)
        payload.accounts = await Services.filterAccounts(payload)
        payload.filters.account = await Common.getAccountId(payload)

        if (!payload.isSuperAdminMaster) {
            payload.columns.splice(1, 1)
        }
        payload.filter()
    },
    methods: {
        filter: function () {
            if (!applySessionScope(this, this.filters)) return

            this.isLoading = true
            this.items = []
            this.enrichFiltersWithPagination()
            Request.do(
                this,
                'POST',
                Request.getDefaultHeader(this),
                this.filters,
                `${Endpoints.companies.filter}`,
                response => {
                    this.applyServerPage(response)
                    this.isLoading = false
                },
                () => {
                    this.isLoading = false
                },
            )
        },
        async selectItem(params) {
            const item = params && params?.row ? JSON.parse(JSON.stringify(params.row)) : this.clientObj

            if (!item.account) {
                item.account = await Common.getAccountId(this)
            } else {
                item.account = item.account._id
            }

            delete item.vgt_id
            delete item.originalIndex

            this.data = item

            this.$bvModal.show('createClientModal')
        },
        clearForm() {
            this.errors = []
            this.$refs.clientModal.clearFields()
            this.isLoading = false
        },
        initTable() {
            this.columns = [
                {
                    label: this.$t('str.table.client.column.name'),
                    field: 'name',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.client.column.account'),
                    field: 'account',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                    sortFn: Common.sortAccountFn,
                },
                {
                    label: this.$t('str.table.client.column.email'),
                    field: 'email',
                    width: '15%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.client.column.phone'),
                    field: 'primaryPhone',
                    type: 'phone',
                    width: '15%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.client.column.owner'),
                    field: 'name',
                    width: '15%',
                    thClass: 'text-nowrap',
                    tdClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.client.column.creat.at'),
                    field: 'createDate',
                    width: '15%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: true,
                    filterable: true,
                },
                {
                    label: this.$t('str.table.client.column.status'),
                    field: 'status',
                    width: '15%',
                    tdClass: 'text-nowrap',
                    thClass: 'text-nowrap',
                    sortable: false,
                    filterable: false,
                },
            ]
            this.paginationOptions = this.buildServerPaginationOptions(this)
        },
        formatDate: Common.formatDateAndTime,
    },
}
</script>
